var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Journey-4---Inbox",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.3--Elements",
    transform: "translate(-771.000000, -305.000000)",
    fill: "#F86B67"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(771.000000, 299.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle",
    transform: "translate(0.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.3,
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.981908,18.1720485 C15.5825894,18.1720485 15.2588776,18.4957603 15.2588776,18.895079 C15.2588776,19.2943977 15.5825894,19.6181094 15.981908,19.6181094 C16.3812267,19.6181094 16.7049385,19.2943977 16.7049385,18.895079 C16.7049385,18.4957603 16.3812267,18.1720485 15.981908,18.1720485 Z M23.696643,19.2349033 L17.8762478,9.11247691 C17.493161,8.42566388 16.7683352,8 15.981908,8 C15.1954809,8 14.4706551,8.42566388 14.0875683,9.11247691 L8.30332462,19.2349033 C7.90714037,19.9030729 7.89850444,20.7320924 8.28068354,21.4083702 C8.66286263,22.0846481 9.37750432,22.5049279 10.1542826,22.5102312 L21.8095335,22.5102312 C22.5927727,22.51795 23.3193336,22.1027989 23.7103656,21.4241112 C24.1013976,20.7454234 24.0961524,19.9086357 23.696643,19.2349033 Z M22.4458003,20.6809642 C22.3167251,20.9106132 22.0729616,21.0518853 21.8095335,21.0497097 L10.1542826,21.0497097 C9.89085449,21.0518853 9.64709096,20.9106132 9.51801578,20.6809642 C9.38885883,20.4572578 9.38885883,20.1816401 9.51801578,19.9579337 L15.3022594,9.83550737 C15.425967,9.59403962 15.6744444,9.44215026 15.9457565,9.44215026 C16.2170686,9.44215026 16.465546,9.59403962 16.5892536,9.83550737 L22.4096488,19.9579337 C22.5557767,20.1786169 22.5696439,20.4615077 22.4458003,20.6954248 L22.4458003,20.6809642 Z M15.981908,12.3878049 C15.5825894,12.3878049 15.2588776,12.7115166 15.2588776,13.1108353 L15.2588776,16.0029571 C15.2588776,16.4022758 15.5825894,16.7259876 15.981908,16.7259876 C16.3812267,16.7259876 16.7049385,16.4022758 16.7049385,16.0029571 L16.7049385,13.1108353 C16.7049385,12.7115166 16.3812267,12.3878049 15.981908,12.3878049 Z",
    id: "Shape",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.cd51ab18238447f75ab52ddc47f2ac28.svg";
export { ForwardRef as ReactComponent };